// extracted by mini-css-extract-plugin
module.exports = {"item":"settings-content_item__QPfUK","active":"settings-content_active__323o9","inactive":"settings-content_inactive__kdQOK"};